/** @format */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ContactSearch from './screens/ContactSearch/ContactSearch.jsx';

// Expose ContactSearch globally
if (window.isWidget) {
	ReactDOM.createRoot(document.getElementById('someContainer')).render(
		<ContactSearch />
	);
}
// Render main app only if not a widget
if (!window.isWidget) {
	const rootElement = document.getElementById('root');
	if (rootElement) {
		const root = ReactDOM.createRoot(rootElement);
		root.render(<App />);
	}
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
